import React from 'react';
import styles from 'assets/css/Card.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import { IconAngleRight, IconCart } from '@ace/react-icons';
import { CardLinkIconWrap } from 'Components/Card/CardLink';
import SMARTGoalPartials from 'Components/Card/Partials/Partials.SMARTGoals';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';
import { joinLastWordWithIcon } from "../../utils/iconUtils";

const CardFooterComponentType = {
    ActionLink: 'ActionLink',
    GroupActionLink: 'GroupActionLink'
}

const CardFooterMessageType = {
    Purchase: 'Purchase',
    Message: 'Message'
}

const SMARTGoalLink = () => {
    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();

    return (
        <span className={buttonStyles.cardFooterLink} onClick={() => toggleSMARTGoalsOverlay()}>
            SMART Goals
            <CardLinkIconWrap>
                <IconAngleRight />
            </CardLinkIconWrap>
        </span>
    );
}

const CardFooter = ({data}) => {
    if (!data)
        return false;

    const { 
        IsSMARTGoalEnabled, 
        HasSMARTGoal, 
        CompletionDate, 
        SMARTGoalStartDate, 
        SMARTGoalEndDate, 
        SMARTGoalTimeLeft,
        CardFooter
    } = data;

    const showSMARTGoalToolLink = (IsSMARTGoalEnabled && !CompletionDate),
        showSMARTGoalInfo = (IsSMARTGoalEnabled && HasSMARTGoal && !CompletionDate),
        showFooter = (CardFooter || showSMARTGoalInfo || showSMARTGoalToolLink);

    if (!showFooter) 
        return false;

    return (
        <footer className={styles.cardFooter}>
            {showSMARTGoalInfo && <span style={{ marginRight: '1rem' }}><SMARTGoalPartials.SMARTGoalDisplay {...{ SMARTGoalStartDate, SMARTGoalEndDate, SMARTGoalTimeLeft }} /></span>}
            {showSMARTGoalToolLink && <SMARTGoalLink />}

            {CardFooter && CardFooter.map(data =>  (
                    data.CardFooterComponentType === CardFooterComponentType.GroupActionLink ? <FooterActionLinks data = { data } /> : <FooterActionLink data = { data } />
                )
            )}
        </footer>
    );
}

const FooterActionLink = ({data}) => {
    const cardFooterMessageType = data?.CardFooterMessage?.GroupCardFooterMessageType?.toLowerCase();
    const linkClass = cardFooterMessageType === CardFooterMessageType.Purchase.toLowerCase() || isPurchaseLink(data.ActionLink.CardLinkText)
        ? buttonStyles.purchase
        : buttonStyles.cardFooterLink;

    return <div className={styles.cardFooterInner}>
        <a className={`${linkClass} ${buttonStyles.micro}`} style={{margin: ".25rem 0"}} key={data.ActionLink.CardLinkText.replace(/ /, "")} href={data.ActionLink.CardLinkUri} target="_blank" rel="noopener noreferrer">
            {joinLastWordWithIcon(data.ActionLink.CardLinkText, <CardLinkIconWrap>
                <IconAngleRight />
            </CardLinkIconWrap>)}
        </a>
        { cardFooterMessageType === CardFooterMessageType.Message.toLowerCase() && <Message data = {data.CardFooterMessage} width ={'100%'} className={styles.message} /> }
        { cardFooterMessageType === CardFooterMessageType.Purchase.toLowerCase() && <Message data = {data.CardFooterMessage} width ={'100%'} className={styles.messagePurchase} /> }
    </div>
}

const FooterActionLinks = ({data}) => {
    return <>
        <div className={styles.cardFooterLinksWrap}>
            {data?.CardFooterActionLinks && data.CardFooterActionLinks.map(item => (
                <FooterActionLink data={item} />
            ))}
        </div>
        {!!data?.CardFooterMessage?.Message && <Message data = { data.CardFooterMessage } width ={ data?.CardFooterActionLinks.length > 1 ? '55%' : '70%'} className={styles.messagePurchase} /> }
    </>
}

const Message = ({data, width, className}) => {
    className = className ?? styles.message;
    
    return <p style={{width:width}} className={className}>
        {data.GroupCardFooterMessageType?.toLowerCase() === CardFooterMessageType.Purchase.toLowerCase() && <IconCart fill="currentColor" className={styles.icon}/>}
        <span>{data.Message}</span>
    </p>
}

function isPurchaseLink(linkText) {
    return linkText.toLowerCase().includes("purchase")
}

export default CardFooter;
